import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";

interface Props {
  open: boolean;
  onClose: () => void;
  onSubmit: (caseStudyText: string) => void;
}

export default function MissingCaseStudyDialog({
  open,
  onClose,
  onSubmit,
}: Props) {
  const [text, setText] = useState("");

  useEffect(() => {
    if (open) setText("");
  }, [open]);

  const handleSubmit = () => {
    const trimmed = text.trim();
    if (!trimmed) return;
    onSubmit(trimmed);
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      PaperProps={{ sx: { borderRadius: 2.5 } }}
    >
      <DialogTitle sx={{ pb: 1 }}>
        <Stack direction="row" alignItems="flex-start" spacing={1}>
          <Box sx={{ flex: 1 }}>
            <Typography
              sx={{ fontSize: 18, fontWeight: 600, color: "#0a0a0a" }}
            >
              Add a case study
            </Typography>
            <Typography variant="body2" sx={{ color: "#717182" }}>
              Share a quick win from a past partnership and the AI will weave it
              into your pitch.
            </Typography>
          </Box>
          <IconButton size="small" onClick={onClose}>
            <Box component="i" className="fa-regular fa-xmark" />
          </IconButton>
        </Stack>
      </DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          fullWidth
          multiline
          minRows={4}
          maxRows={8}
          size="small"
          placeholder="e.g. Drove 4.2k clicks for Brand X via a UGC reel that hit 80k views."
          value={text}
          onChange={(e) => setText(e.target.value)}
          sx={{
            "& .MuiOutlinedInput-root": {
              backgroundColor: "#f3f3f5",
              "& fieldset": { borderColor: "transparent" },
            },
          }}
        />
      </DialogContent>
      <DialogActions
        sx={{ px: 3, py: 2, borderTop: "1px solid rgba(0,0,0,0.1)" }}
      >
        <Button
          onClick={onClose}
          variant="outlined"
          size="small"
          sx={{
            textTransform: "none",
            borderColor: "rgba(0,0,0,0.1)",
            color: "#0a0a0a",
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={handleSubmit}
          disabled={!text.trim()}
          variant="contained"
          size="small"
          disableElevation
          sx={{
            textTransform: "none",
            backgroundColor: "#8084FF",
            "&:hover": { backgroundColor: "#6970E8" },
          }}
        >
          Save & generate
        </Button>
      </DialogActions>
    </Dialog>
  );
}
